import type { GraphLocationDescriptor } from '@ipfabric/utils';
import { type MenuTreeNode, isPageItem } from '../menuTree';

export const getUrl = (
  menuTreeNode: MenuTreeNode,
): GraphLocationDescriptor | string | undefined => {
  if (menuTreeNode.urlList === undefined) {
    return undefined;
  }

  const urlItem = menuTreeNode.urlList[0];
  const url = isPageItem(urlItem) ? urlItem.url : urlItem;

  return typeof url !== 'function' ? url : undefined;
};
